



















import { Component } from "vue-property-decorator";
import WidgetBase from "../WidgetBase";
import MagicValidator from "../../../magic/MagicValidator.vue";
import { signatureDefaultIcon } from "./icon";
@Component({
  name: "StampWidget",
  components: { MagicValidator }
})
export default class StampWidget extends WidgetBase<App.WebForm.StampWidget> {
  private getProtectList(target: App.WebForm.StampWidget, protects: string[]) {
    console.log(
      "target.name => " + target.name + ", " + target.property.propertyName
    );
    protects.unshift(...target.protects);
    // 避免原有前置章选到自身导致的死循环问题
    if (target.prefix === target.property.propertyName) return;
    if (target.prefix) {
      const prefix = this.htmlOptions.options.widgets.find(
        (d) => d.property.propertyName === target.prefix
      ) as App.WebForm.StampWidget;
      if (prefix) {
        console.log(
          "prefix.name => " + prefix.name + ", " + prefix.property.propertyName
        );
        this.getProtectList(prefix, protects);
      }
    }
  }

  signature() {
    const _this = this;

    if (this.widget.readonly === true) return;

    // 根据前置项递归计算本签章的保护箱
    const result: string[] = [];
    this.getProtectList(this.widget, result);
    const protects: string[] = [...new Set(result)];

    const signatureCreator = Signature.create();
    signatureCreator.run({
      protectedItems: protects, //设置定位页面DOM的id，自动查找ID，自动获取保护DOM的kg-desc属性作为保护项描述，value属性为保护数据。不设置，表示不保护数据，签章永远有效。
      position: this.widget.property.propertyName, //设置盖章定位dom的ID，必须设置
      autoCert: false,
      okCall: function (
        fn: any,
        image: { height: string; width: string; imgdata: string }
      ) {
        console.log("签章成功", image);

        const sign = {
          signatureId: this.getSignatureid(),
          signatureData: this.getSignatureData(),
          base64: "data:image/png;base64," + image.imgdata,
          width: image.width,
          height: image.height,
          marginTop: 0,
          marginLeft: 0
        };

        _this.$set(_this.widget, "value", JSON.stringify(sign));
        fn(true);
      },
      cancelCall: function () {
        console.log("取消签章");
      }
    });
  }

  get stampIcon() {
    return signatureDefaultIcon;
  }
  get style() {
    return {
      height: this.widget.height + "px"
    };
  }
}
